app.service('clientService', function ($http) {

  // Routes -----------------------------------------

  this.activateAccount = obj => {
    return $http.post('/client/activateAccount', obj)
      .then(function (response) {
        return response
      })
  }
  this.activateAccount = obj => {
    return $http.post('/client/activateAccount', obj)
      .then(function (response) {
        return response
      })
  }


  this.activateAccount = obj => {
    return $http.post('/client/activateAccount', obj)
      .then(function (response) {
        return response
      })
  }

  this.loadEmailEvents = obj => {
    return $http.post('/client/loadEmailEvents', obj)
      .then(function (response) {
        return response
      })
  }

  this.loadMessage = obj => {
    return $http.post('/client/loadMessage', obj)
      .then(function (response) {
        return response
      })
  }

  this.emailHistoryPdf = obj => {
    return $http.post('/client/emailHistoryPdf', obj)
      .then(function (response) {
        return response
      })
  }

  this.getEmailOpens = obj => {
    return $http.post('/client/getEmailOpens', obj)
      .then(function (response) {
        return response
      })
  }

  this.resendEmail = obj => {
    return $http.post('/client/resendEmail', obj)
      .then(function (response) {
        return response
      })
  }

  this.getEmailHistory = obj => {
    return $http.post('/client/getEmailHistory', obj)
      .then(function (response) {
        return response
      })
  }

  // { thread_id } | { reply_id }  -> sent CRM email + its replies (client details conversation modal)
  this.getEmailConversation = obj => {
    return $http.post('/emailCreator/getConversation', obj)
      .then(function (response) {
        return response
      })
  }

  this.sendEmailViaTemplate = obj => {
    return $http.post('/emailCreator/sendEmailViaTemplate', obj)
      .then(function (response) {
        return response
      })
  }

  this.loadDocumentInfoByProperty = obj => {
    return $http.post('/client/loadDocumentInfoByProperty', obj)
      .then(function (response) {
        return response
      })
  }

  this.loadDocumentInfoByProperty = obj => {
    return $http.post('/client/loadDocumentInfoByProperty', obj)
      .then(function (response) {
        return response
      })
  }

  this.mergePropertiesToAccount = obj => {
    return $http.post('/client/mergePropertiesToAccount', obj)
      .then(function (response) {
        return response
      })
  }

  this.loadMergeDetails = obj => {
    return $http.post('/client/loadMergeDetails', obj)
      .then(function (response) {
        return response
      })
  }

  this.convertToPartner = obj => {
    return $http.post('/client/convertToPartner', obj)
      .then(function (response) {
        return response
      })
  }

  this.findUserByTaxID = obj => {
    console.log("findUserByTaxID");
    return $http.post('/client/findUserByTaxID', obj)
      .then(function (response) {
        return response
      })
  }

  this.findUserByPropID = obj => {
    console.log("findUserByTaxID");
    return $http.post('/client/findUserByPropID', obj)
      .then(function (response) {
        return response
      })
  }

  this.findUsersByCadAccount = obj => {
    return $http.post('/client/findUsersByCadAccount', obj)
      .then(function (response) {
        return response
      })
  }

  this.findUserByAnyKey = obj => {
    return $http.post('/client/findUserByAnyKey', obj)
      .then(function (response) {
        return response
      })
  }

  this.commentsManager = obj => {
    return $http.post('/comments/manager', obj)
      .then(function (response) {
        return response
      })
  }

  this.updateClientDetails = function (obj) {
    return $http.post('/client/updateClientDetails', obj)
      .then(function (response) {
        return response
      })
  }

  this.createClientAccount = function (obj) {
    return $http.post('/client/createClientAccount', obj)
      .then(function (response) {
        return response
      })
  }

  this.loadClientDetails = function (obj) {
    return $http.post('/client/loadClientDetails', obj)
      .then(function (response) {
        return response
      })
  }

  this.getClientPayments = function (obj) {
    return $http.post('/client/getClientPayments', obj)
      .then(function (response) {
        return response
      })
  }

  this.getAdditionalEmails = function (obj) {
    return $http.post('/client/getAdditionalEmails', obj)
      .then(function (response) {
        return response
      })
  }

  this.addAdditionalEmail = function (obj) {
    return $http.post('/client/addAdditionalEmail', obj)
      .then(function (response) {
        return response
      })
  }

  this.updateAdditionalEmail = function (obj) {
    return $http.post('/client/updateAdditionalEmail', obj)
      .then(function (response) {
        return response
      })
  }

  this.deleteAdditionalEmail = function (obj) {
    return $http.post('/client/deleteAdditionalEmail', obj)
      .then(function (response) {
        return response
      })
  }

  // Authorized users on the account (shared with the Dashboard's Edit Profile)
  this.getAuthorizedUsers = function (obj) {
    return $http.post('/client/getAuthorizedUsers', obj)
      .then(function (response) {
        return response
      })
  }

  this.addAuthorizedUser = function (obj) {
    return $http.post('/client/addAuthorizedUser', obj)
      .then(function (response) {
        return response
      })
  }

  this.updateAuthorizedUser = function (obj) {
    return $http.post('/client/updateAuthorizedUser', obj)
      .then(function (response) {
        return response
      })
  }

  this.setAuthorizedUserStatus = function (obj) {
    return $http.post('/client/setAuthorizedUserStatus', obj)
      .then(function (response) {
        return response
      })
  }

  this.removeAuthorizedUser = function (obj) {
    return $http.post('/client/removeAuthorizedUser', obj)
      .then(function (response) {
        return response
      })
  }

  this.resendAuthorizedUserInvite = function (obj) {
    return $http.post('/client/resendAuthorizedUserInvite', obj)
      .then(function (response) {
        return response
      })
  }

  this.sendAuthorizedUserReset = function (obj) {
    return $http.post('/client/sendAuthorizedUserReset', obj)
      .then(function (response) {
        return response
      })
  }

  this.unlockAuthorizedUser = function (obj) {
    return $http.post('/client/unlockAuthorizedUser', obj)
      .then(function (response) {
        return response
      })
  }

  this.getAuthorizedUserActivity = function (obj) {
    return $http.post('/client/getAuthorizedUserActivity', obj)
      .then(function (response) {
        return response
      })
  }

  this.loadIntercomChats = function (obj) {
    return $http.post('/client/loadIntercomChats', obj)
      .then(function (response) {
        return response
      })
  }

  this.sendIntercomReply = function (obj) {
    return $http.post('/client/sendIntercomReply', obj)
      .then(function (response) {
        return response
      })
  }

  this.loadIntercomConversation = function (obj) {
    return $http.post('/client/loadIntercomConversation', obj)
      .then(function (response) {
        return response
      })
  }

  this.createIntercomConversation = function (obj) {
    return $http.post('/client/createIntercomConversation', obj)
      .then(function (response) {
        return response
      })
  }
  //-------------------------------------------------

  let clientMode = null,
    clientObj = null

  this.setClientMode = (mode) => {
    clientMode = mode
  }
  this.getClientMode = () => {
    return clientMode
  }

  this.setClientObj = (obj) => {
    clientObj = obj
  }
  this.getClientObj = () => {
    return clientObj
  }

})